import { Alert, Box, Button } from "@mui/material";

import { acaoReterSelecionadas } from "./retencao-vocabulario";

interface IProps {
  quantidade: number;
  onReter: () => void;
  /** Resultado da última marcação em lote, mostrado até a próxima. */
  resumo?: string;
}

export function BarraReterEmLote({ quantidade, onReter, resumo }: IProps) {
  if (quantidade === 0 && !resumo) return null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
      {quantidade > 0 && (
        <Button variant="outlined" color="error" size="small" onClick={onReter}>
          {acaoReterSelecionadas(quantidade)}
        </Button>
      )}
      {resumo && <Alert severity="info">{resumo}</Alert>}
    </Box>
  );
}
